import React, { Component } from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  checkError,
  restRequest,
  GetDateString,
  getOrganizationDate,
} from '../../../Helpers';
import { Loader, NotFound } from '../../';
import PurchaseOrderEnhancedForm, {
  getTaxAmount,
} from './PurchaseOrderFormEnhancer';
import './PurchaseOrderForm.css';
import './../../Table/Table.css';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

class PurchaseOrderForm extends Component {
  type = this.props.type; // "add", "edit", "clone", "dropship", "backorder"
  id =
    this.props.idFromHeaderWrapper ||
    this.props.id ||
    this.props.match.params.id ||
    null;
  vendorId = window.location.search.split('=')[1] || null;
  state = {
    loading: true,
    shippingAddress: {},
    purchaseOrder: {
      items: [],
      vendorID: null,
      contactObj: {},
      objectId: null,
      reference: '',
      adjustment: 0,
      warehouseID: null,
      purchaseOrderNo: '',
      transactionDiscount: 0,
      termsAndConditions: '',
      purchaseOrderType: this.type,
      hasTermsAndConditions: false,
      transactionDiscountType: 'percent', // percent, amount
      purchaseDate: moment(getOrganizationDate()).format('YYYY-MM-DD 00:00:00'),
      deliveryDate: moment(getOrganizationDate()).format('YYYY-MM-DD 00:00:00'),
    },
    taxFromDB: [],
    itemsFromDB: [],
    notFound: false,
    vendorsFromDB: [],
    showPrompt: false,
    cofirmState: false,
    warehouseFromDB: [],
    stockPreference: '',
    organizationCurrency: {},
    previousPurchasePrices: [],
    accountsFromDB: { expense: [], inventory: [] },
    // termsAndConditions: '',
    // hasTermsAndConditions: false,
  };

  emptyItem = {
    tax: {
      id: null,
      name: '',
      rate: 0,
    },
    sku: '',
    id: null,
    name: '',
    images: [],
    stocks: [],
    quantity: 1,
    unit: 'unit',
    total: '0.00',
    taxAmount: 0,
    unitPrice: null,
    accountID: null,
    extra_description: '',
    previousPurchasePrice: 0,
    dragDropID: GetDateString(),
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.fetchData().then(() => this.setState({ loading: false }));
    sessionStorage.setItem('once', false);
    sessionStorage.setItem('fullscreen', false);
    window.onbeforeunload = function () {
      return true;
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  fetchData = async () => {
    this.setState({ loading: true });
    switch (this.type) {
      case 'add':
        await this.fetchPurchaseOrderCreateData();
        if (this.vendorId) {
          await this.fetchVendorDetail(this.vendorId);
        }
        break;
      case 'edit':
        await this.fetchPurchaseOrderEditData();
        break;
      case 'clone':
        await this.fetchPurchaseOrderCloneData();
        break;
      case 'dropship':
        await this.fetchPurchaseOrderDropshipBackorderData(
          this.props.dropshipItems
        );
        break;
      case 'backorder':
        await this.fetchPurchaseOrderDropshipBackorderData(
          this.props.backorderItems,
          this.props.warehouseID
        );
        break;
      default:
        break;
    }

    this.setState({ loading: false });
  };

  getWarehouseID(warehouseList) {
    return !!warehouseList.length
      ? warehouseList.find((warehouse) => warehouse.is_primary).id
      : null;
  }

  async fetchPurchaseOrderCreateData() {
    return restRequest('get', 'purchaseorders/create')
      .then((res) => {
        // Removes inactive warehouse from list
        res.warehouse_list = res.warehouse_list.filter(
          (list) => list.is_active === 1
        );
        this.setState({
          taxFromDB: res.tax_list,
          itemsFromDB: res.item_list,
          vendorsFromDB: res.vendor_list,
          warehouseFromDB: res.warehouse_list,
          organizationCurrency: res.base_currency,
          accountsFromDB: {
            expense: res.expense_accounts || [],
            inventory: res.inventory_accounts || [],
          },
          stockPreference: res.stock_preference.preferences.physical
            ? 'physical'
            : 'accounting',
          purchaseOrder: {
            ...this.state.purchaseOrder,
            items: [this.emptyItem],
            purchaseOrderNo: res.purchase_order_no,
            warehouseID: this.getWarehouseID(res.warehouse_list),
            termsAndConditions: res.purchase_order_preference.terms,
          },
        });
      })
      .catch((error) => checkError(error));
  }

  async fetchVendorDetail(vendorId) {
    return restRequest('get', `contacts/${vendorId}`).then((res) => {
      let purchaseOrder = {
        ...this.state.purchaseOrder,
        contactObj: {
          value: res.id,
          label: res.display_name,
        },
      };
      this.setState({
        purchaseOrder: purchaseOrder,
      });
    });
  }

  async fetchPurchaseOrderDropshipBackorderData(items, warehouseID = null) {
    return restRequest(
      'get',
      'purchaseorders/create?saleOrderId=' + items[0].saleOrderId
    )
      .then((res) => {
        let dropshipBackorderItems = items.map((dropshipBackorderItem) => {
          let foundItem = res.item_list.find(
            (item) => item.id === dropshipBackorderItem.itemId
          );
          return {
            ...foundItem,
            id: foundItem.id,
            sku: foundItem.sku,
            name: foundItem.name,
            unit: foundItem.unit,
            total: foundItem.amount,
            stocks: foundItem.stocks,
            images: foundItem.images,
            dragDropID: GetDateString(),
            accountID: foundItem.purchase_account_id,
            quantity: dropshipBackorderItem.quantity,
            unitPrice: foundItem.purchase_unit_price,
            salesOrderItemDetailId: dropshipBackorderItem.id,
            tax: {
              id: foundItem.tax ? foundItem.tax.id : null,
              rate: foundItem.tax ? foundItem.tax.rate : 0,
              name: foundItem.tax ? foundItem.tax.name : '',
            },
            taxAmount: foundItem.tax_id
              ? getTaxAmount(
                  dropshipBackorderItem.quantity,
                  foundItem.purchase_unit_price,
                  foundItem.tax.rate
                )
              : 0,
            extra_description: dropshipBackorderItem.extra_description
              ? dropshipBackorderItem.extra_description
              : '',
          };
        });
        this.setState({
          itemsFromDB: [],
          taxFromDB: res.tax_list,
          vendorsFromDB: res.vendor_list,
          warehouseFromDB: res.warehouse_list,
          shippingAddress: res.shipping_address,
          organizationCurrency: res.base_currency,
          accountsFromDB: {
            expense: res.expense_accounts || [],
            inventory: res.inventory_accounts || [],
          },
          stockPreference:
            res.stock_preference === 1 ? 'physical' : 'accounting',
          purchaseOrder: {
            ...this.state.purchaseOrder,
            objectId: res.id,
            warehouseID: warehouseID,
            items: dropshipBackorderItems,
            purchaseOrderNo: res.purchase_order_no,
            termsAndConditions: res.purchase_order_preference.terms,
          },
        });
      })
      .catch((error) => checkError(error));
  }

  async fetchPurchaseOrderCloneData() {
    return restRequest('get', `purchaseorders/${this.id}/clone`)
      .then((res) => {
        let itemsList =
          res.purchase_order_details.purchase_order_item_details.map(
            (item) => ({
              id: item.item.id,
              sku: item.item.sku,
              ean: item.item.ean,
              mpn: item.item.mpn,
              upc: item.item.upc,
              unit: item.item.unit,
              name: item.item.name,
              isbn: item.item.isbn,
              unitPrice: item.rate,
              quantity: item.quantity,
              images: item.item.images,
              stocks: item.item.stocks,
              accountID: item.account_id,
              dragDropID: GetDateString(),
              tax: {
                id: item.tax_id ? item.tax_id : null,
                rate: item.tax_id ? item.tax_rate : 0,
                name: item.tax_id ? item.tax_name : '',
              },
              total: item.amount,
              extra_description: item.extra_description,
              taxAmount: item.tax_id ? item.tax_amount : 0,
            })
          );
        let promises = [];
        itemsList.forEach((item, index) => {
          let POPURL = null;
          // if(res.purchase_order_details.id){
          //   POPURL = `purchaseorders/previouspurchaseprice?vendor_id=${res.purchase_order_details.vendor.id}&item_id=${item.id}&object=purchaseOrder&object_id=${res.purchase_order_details.id}`;
          // }else{
          POPURL = `purchaseorders/previouspurchaseprice?vendor_id=${res.purchase_order_details.vendor.id}&item_id=${item.id}`;
          // }
          promises.push(restRequest('get', POPURL));
        });
        Promise.all(promises).then((promisRes) => {
          this.setState({ previousPurchasePrices: promisRes });
        });
        this.setState({
          taxFromDB: res.tax_list,
          itemsFromDB: res.item_list,
          vendorsFromDB: res.vendor_list,
          warehouseFromDB: res.warehouse_list,
          accountsFromDB: {
            expense: res.expense_accounts || [],
            inventory: res.inventory_accounts || [],
          },
          stockPreference:
            res.stock_preference === 1 ? 'physical' : 'accounting',
          organizationCurrency: res.base_currency,
          purchaseOrder: {
            ...this.state.purchaseOrder,
            ...{
              purchaseOrderNo: res.new_purchase_order_no,
              vendorID: res.purchase_order_details.vendor.id,
              contactObj: {
                value: res.purchase_order_details.vendor.id,
                label: res.purchase_order_details.vendor.display_name,
              },
              purchaseDate: moment(
                res.purchase_order_details.order_date
              ).format('YYYY-MM-DD 00:00:00'),
              deliveryDate: moment(
                res.purchase_order_details.expected_delivery_date
              ).format('YYYY-MM-DD 00:00:00'),
              reference: res.purchase_order_details.reference,
              warehouseID: res.purchase_order_details.warehouse_id,
              transactionDiscountType:
                res.purchase_order_details.discount_type || 'percent',
              transactionDiscount:
                res.purchase_order_details.discount_transaction_level,
              adjustment: res.purchase_order_details.adjustment,
              hasTermsAndConditions:
                res.purchase_order_details.terms_and_conditions !== null &&
                res.purchase_order_details.terms_and_conditions.length > 0
                  ? true
                  : false,
              termsAndConditions: res.purchase_order_preference.terms,
              items: itemsList,
            },
          },
        });
      })
      .catch((error) => checkError(error));
  }

  buildItemList(items) {
    return items.map((item) => ({
      id: item.item.id,
      sku: item.item.sku,
      ean: item.item.ean,
      mpn: item.item.mpn,
      upc: item.item.upc,
      unitPrice: item.rate,
      unit: item.item.unit,
      isbn: item.item.isbn,
      name: item.item.name,
      quantity: item.quantity,
      images: item.item.images,
      stocks: item.item.stocks,
      accountID: item.account_id,
      dragDropID: GetDateString(),
      purchaseOrderItemDetailId: item.id,
      purchase_unit_price: item.item.purchase_unit_price,
      tax: {
        id: item.tax ? item.tax.id : null,
        rate: item.tax ? item.tax.rate : 0,
        name: item.tax ? item.tax.name : '',
      },
      total: item.amount,
      taxAmount: item.tax_id ? item.tax_amount : 0,
      extra_description: item.extra_description,
    }));
  }

  async fetchPurchaseOrderEditData() {
    return restRequest('get', `purchaseorders/${this.id}/edit`)
      .then((res) => {
        //let result = this.buildItemList(res.purchase_order_details.purchase_order_item_details)
        //let itemsList = res.item_list.filter(item =>  result.find(y => y.id === item.id) ? null : item)
        let itemsList = res.item_list;
        let purchaseOrderItems = this.buildItemList(
          res.purchase_order_details.purchase_order_item_details
        );
        // purchaseOrderItems.forEach((item, index) => {
        //   restRequest('get', `purchaseorders/previouspurchaseprice?vendor_id=${res.purchase_order_details.vendor_id}}&item_id=${item.id}`).then(previousPrice => {
        //     purchaseOrderItems[index] = { ...item, previousPurchasePrice: previousPrice }
        //   })
        // })
        let promises = [];
        purchaseOrderItems.forEach((item, index) => {
          let POPURL = null;
          if (res.purchase_order_details.id) {
            POPURL = `purchaseorders/previouspurchaseprice?vendor_id=${res.purchase_order_details.vendor_id}&item_id=${item.id}&object=purchaseOrder&object_id=${res.purchase_order_details.id}`;
          } else {
            POPURL = `purchaseorders/previouspurchaseprice?vendor_id=${res.purchase_order_details.vendor_id}&item_id=${item.id}`;
          }
          promises.push(restRequest('get', POPURL));
        });
        Promise.all(promises).then((promisRes) => {
          this.setState({ previousPurchasePrices: promisRes });
        });
        this.setState({
          itemsFromDB: itemsList,
          taxFromDB: res.tax_list,
          vendorsFromDB: res.vendor_list,
          warehouseFromDB: res.warehouse_list,
          accountsFromDB: {
            expense: res.expense_accounts || [],
            inventory: res.inventory_accounts || [],
          },
          stockPreference:
            res.stock_preference === 1 ? 'physical' : 'accounting',
          organizationCurrency: res.base_currency,
          purchaseOrder: {
            ...this.state.purchaseOrder,
            ...{
              vendorID: res.purchase_order_details.vendor.id,
              purchaseOrderNo: res.purchase_order_details.purchase_order_no,
              contactObj: {
                value: res.purchase_order_details.vendor.id,
                label: res.purchase_order_details.vendor.display_name,
              },
              purchaseDate: moment(
                res.purchase_order_details.order_date
              ).format('YYYY-MM-DD 00:00:00'),
              deliveryDate: moment(
                res.purchase_order_details.expected_delivery_date
              ).format('YYYY-MM-DD 00:00:00'),
              reference: res.purchase_order_details.reference,
              status: res.purchase_order_details.status,
              warehouseID: res.purchase_order_details.warehouse_id,
              transactionDiscountType:
                res.purchase_order_details.discount_type || 'percent',
              transactionDiscount:
                res.purchase_order_details.discount_transaction_level,
              adjustment: res.purchase_order_details.adjustment,
              hasTermsAndConditions:
                res.purchase_order_details.terms_and_conditions !== '' &&
                res.purchase_order_details.terms_and_conditions.length > 0
                  ? true
                  : false,
              termsAndConditions:
                res.purchase_order_details.terms_and_conditions !== '' &&
                res.purchase_order_details.terms_and_conditions.length > 0
                  ? res.purchase_order_details.terms_and_conditions
                  : res.purchase_order_preference.terms,
              objectId: this.id,
              items: purchaseOrderItems,
            },
          },
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        //this.props.handleToast(error, 'error')
        this.setState({ notFound: true });
      });
  }
  updateTaxList = (newTax) => {
    this.setState((state) => ({ taxFromDB: [newTax, ...state.taxFromDB] }));
  };
  updateVendorList = (newVendor) => {
    this.setState((state) => ({
      vendorsFromDB: [newVendor, ...state.vendorsFromDB],
    }));
  };

  submitRequestType() {
    switch (this.type) {
      case 'edit':
        return 'put';
      case 'add':
      case 'clone':
      case 'dropship':
      case 'backorder':
      default:
        return 'post';
    }
  }

  submitRequestUrl() {
    switch (this.type) {
      case 'edit':
        return `purchaseorders/${this.props.id}`;
      case 'add':
      case 'clone':
      case 'dropship':
      case 'backorder':
      default:
        return 'purchaseorders';
    }
  }

  successMessage = () => {
    const { t } = this.props;
    switch (this.type) {
      case 'edit':
        this.props.handleToast(t('PurchaseOrder.po_updated'), 'success');
        break;
      case 'clone':
        this.props.handleToast(t('PurchaseOrder.po_cloned'), 'success');
        break;
      case 'dropship':
        this.props.handleToast(t('PurchaseOrder.ds_created'), 'success');
        break;
      case 'backorder':
        this.props.handleToast(t('PurchaseOrder.bo_created'), 'success');
        break;
      case 'add':
      default:
        this.props.handleToast(t('PurchaseOrder.po_created'), 'success');
        break;
    }
  };

  handleTotalCheckTrue = (check) => {
    this.setState({
      cofirmState: check,
    });
  };

  handleTotalCheckFalse = (check) => {
    this.setState({
      cofirmState: check,
    });
  };

  handlePrompt = (status = true) => this.setState({ showPrompt: status });

  renderPurchaseOrderForm() {
    const { title = '', history, handleToast } = this.props;
    const {
      taxFromDB,
      itemsFromDB,
      cofirmState,
      purchaseOrder,
      vendorsFromDB,
      accountsFromDB,
      shippingAddress,
      warehouseFromDB,
      stockPreference,
      organizationCurrency,
      previousPurchasePrices,
      //hasTermsAndConditions,
    } = this.state;
    return (
      <>
        <Prompt
          when={this.state.showPrompt}
          message={t('common.leave_page_warning')}
        />
        <PurchaseOrderEnhancedForm
          id={this.id}
          title={title}
          type={this.type}
          history={history}
          taxFromDB={taxFromDB}
          className="po-add-form"
          cofirmState={cofirmState}
          handleToast={handleToast}
          itemsFromDB={itemsFromDB}
          emptyItem={this.emptyItem}
          setPrompt={this.handlePrompt}
          vendorsFromDB={vendorsFromDB}
          accountsFromDB={accountsFromDB}
          shippingAddress={shippingAddress}
          stockPreference={stockPreference}
          warehouseFromDB={warehouseFromDB}
          updateTaxList={this.updateTaxList}
          vendorIdTransaction={this.vendorId}
          purchaseOrder={{ ...purchaseOrder }}
          requestUrl={this.submitRequestUrl()}
          successMessage={this.successMessage}
          requestType={this.submitRequestType()}
          updateVendorList={this.updateVendorList}
          organizationCurrency={organizationCurrency}
          previousPurchasePrices={previousPurchasePrices}
          handleTotalCheckTrue={this.handleTotalCheckTrue}
          handleTotalCheckFalse={this.handleTotalCheckFalse}
          // hasTermsAndConditions={hasTermsAndConditions}
        />
      </>
    );
  }

  render() {
    if (this.state.loading) return <Loader />;
    if (this.state.notFound) return <NotFound />;
    return this.renderPurchaseOrderForm();
  }
}

export default withRouter(withTranslation()(PurchaseOrderForm));
